import { useQueryClient } from '@tanstack/react-query';
import {
  createDevice,
  updateDevice,
  deleteDevice as deleteDeviceApi
} from '../services/deviceService';

export default function useDeviceActions() {
  const queryClient = useQueryClient();

  const reload = () => {
    queryClient.invalidateQueries(['devices']);
  };

  const saveDevice = async (mode, id, values) => {
    try {
      if (mode === 'create') {
        await createDevice(values);
        return { success: true, message: 'Device created' };
      } else {
        await updateDevice(id, values);
        return { success: true, message: 'Device updated' };
      }
    } catch (err) {
      console.error("Error saving device:", err);
      return { success: false, message: 'Failed to save device' };
    }
  };

  const deleteDevice = async (id) => {
    try {
      await deleteDeviceApi(id);
      return { success: true, message: 'Device deleted' };
    } catch (err) {
      console.error("Error deleting device:", err);
      return { success: false, message: 'Failed to delete device' };
    }
  };

  return { saveDevice, deleteDevice, reload };
}
